const MESSAGE_PREFIX = '[aria2.ts]: ';

/// The whole assert part is basically copied from typescript repo.
export function fail(message?: string): never {
  // const isProduction = true;
  // if (isProduction) return;
  failInDebug(message);
}

export function failInDebug(message?: string): never {
  // eslint-disable-next-line no-debugger
  debugger;
  const e = new Error(message ? `Debug Failure.${message} ` : 'Debug Failure.');
  throw e;
}

export function assert(expression: unknown, message?: string, verboseDebugInfo?: string | (() => string)): asserts expression {
  if (!expression) {
    const messagePostfix = message ? `with message "${message}"` : '';
    message = `${MESSAGE_PREFIX}assert failed${messagePostfix}`;
    if (verboseDebugInfo) {
      message += `\r\nVerbose Debug Information: ${typeof verboseDebugInfo === 'string' ? verboseDebugInfo : verboseDebugInfo()}`;
    }
    fail(message);
  }
}

export function assertIsDefined<T>(value: T, message?: string): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    fail(message);
  }
}

export function assertNever(member: never, message = 'Assert never:'): never {
  const detail = JSON.stringify(member);
  return failInDebug(`${message} ${detail} `);
}
